import { render, staticRenderFns } from "./TournamentCardContainer.vue?vue&type=template&id=1eb9b6a4&"
import script from "./TournamentCardContainer.vue?vue&type=script&lang=ts&"
export * from "./TournamentCardContainer.vue?vue&type=script&lang=ts&"
import style0 from "./TournamentCardContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VListItemSubtitle,VRow})
